import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class DeleteIMEIApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/netChannelContent/DeleteAllIMEI',
      requesterInfo,
    })
  }

  public async deleteIMEI(): Promise<any> {
    return await this.deleteAsync<any>()
  }
}
